export default __webpack_public_path__ + "static/media/close-left-bar.990ba922.svg";